import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core'
import { NgElement, WithProperties } from '@angular/elements'
import { registerCustomElementFactory } from '../../../custom-elements/register-custom-element-factory'
import { DecodeHtmlStringPipe } from '../../../pipes'

/**
 * @public
 */
export type CardHeaderElement = NgElement & WithProperties<CardHeaderComponent>

/**
 * @public
 */
@Component({
  selector: 'gpei-card-header',
  templateUrl: './card-header.component.html',
  styleUrls: [ './card-header.component.sass' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: true,
  imports: [
    DecodeHtmlStringPipe
  ]
})
export class CardHeaderComponent {

  @Input()
  @HostBinding()
  text: string

}

/**
 * @public
 */
export const registerCardHeaderElement = registerCustomElementFactory(CardHeaderComponent)
